const userNameRegex = /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]+$/ // accepts letters, accents and spaces
export default userNameRegex
